if (!customElements.get('cart-section')) {
  class CartSection extends HTMLElement {
    constructor() {
      super();
    }

    update(event) {
      if(!event.detail.mainCart) return;

      const html = new DOMParser().parseFromString(event.detail.mainCart, 'text/html');
      if (!html) return;

      const cartSection = html.querySelector('cart-section');
      if (!cartSection) return;

      this.innerHTML = cartSection.innerHTML;
    }

    connectedCallback() {
      document.addEventListener('alexa:update-cart', this.update.bind(this));
    }
  }
  customElements.define('cart-section', CartSection);
}
